import { render } from "./CompanyBoards.vue?vue&type=template&id=2b695b05&scoped=true&ts=true"
import script from "./CompanyBoards.vue?vue&type=script&lang=ts"
export * from "./CompanyBoards.vue?vue&type=script&lang=ts"

import "./CompanyBoards.vue?vue&type=style&index=0&id=2b695b05&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b695b05"]])

export default __exports__